export default {
  partner: {},
  partners: [],
  unvaluedPartners: [],
};
